import React, {useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import {InlineWidget} from "react-calendly";
import {useTranslation} from "react-i18next";

const Contact = () => {
    const {t} = useTranslation();
    const [calendlyEnabled, setCalendlyEnabled] = useState(false)

    return (
        <Container
            fluid
            className="py-5"
            id="contact"
        >
            <h2 className="text-center mb-4">{t("pages.home.contact.title")}</h2>
            <Row className="justify-content-center"
            >
                <Col md={6}>
                    <div className={"p-5 text-center"}>
                        {!calendlyEnabled && <button className={"btn btn-primary btn-lg text-white"} onClick={() => {
                            setCalendlyEnabled(!calendlyEnabled)
                        }}
                        >{t("pages.home.contact.buttonCta")}
                        </button>}
                        {calendlyEnabled && <InlineWidget url="https://calendly.com/ucarsolutions/dmarc-flow"/>}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Contact;
